import { z } from 'zod';

import { SupportedOperands } from '../const';
import { PostfixCriteriaSchema } from '../postfixCriteria';

export type SupportedOperandsType = keyof typeof SupportedOperands;

export const NotificationWhereSchema = PostfixCriteriaSchema.optional();

type NotificationWhere = z.infer<typeof NotificationWhereSchema>;

export default NotificationWhere;
